import React from 'react';
import { getStrategyOptions } from '../routes/ScoringConfigUI';

const ScoringStrategySelector = ({ value, onChange, config, onConfigChange, templateMode }) => {
  const strategies = getStrategyOptions(templateMode);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Scoring Strategy
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="select-field w-full"
      >
        {strategies.map((strategy) => (
          <option key={strategy.value} value={strategy.value}>
            {strategy.label}
          </option>
        ))}
      </select>
      
      {/* Additional config options based on strategy */}
      {value === 'Custom' && (
        <div className="mt-2 space-y-2">
          <div>
            <label className="block text-xs text-gray-600">
              Minimum Score
            </label>
            <input
              type="number"
              value={config?.minScore || 0}
              onChange={(e) => onConfigChange({ ...config, minScore: parseFloat(e.target.value) })}
              className="input-field w-full mt-1"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600">
              Maximum Score
            </label>
            <input
              type="number"
              value={config?.maxScore || 10}
              onChange={(e) => onConfigChange({ ...config, maxScore: parseFloat(e.target.value) })}
              className="input-field w-full mt-1"
            />
          </div>
        </div>
      )}
      {value === 'CustomWeight' && (
        <div className="mt-2 space-y-2">
          <div>
            <label className="block text-xs text-gray-600">
              Minimum Score
            </label>
            <input
              type="number"
              value={config?.minScore ?? 1}
              onChange={(e) => onConfigChange({ ...config, minScore: parseFloat(e.target.value) })}
              className="input-field w-full mt-1"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600">
              Maximum Score
            </label>
            <input
              type="number"
              value={config?.maxScore ?? 5}
              onChange={(e) => onConfigChange({ ...config, maxScore: parseFloat(e.target.value) })}
              className="input-field w-full mt-1"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600">
              Weight % toward final score
            </label>
            <input
              type="number"
              step="0.1"
              value={config?.weightPct ?? 1}
              onChange={(e) => onConfigChange({ ...config, weightPct: parseFloat(e.target.value) })}
              className="input-field w-full mt-1"
              placeholder="e.g. 23.2"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoringStrategySelector;
